import { render, staticRenderFns } from "./Passengeradd.vue?vue&type=template&id=bce6c47a&scoped=true"
import script from "./Passengeradd.vue?vue&type=script&lang=js"
export * from "./Passengeradd.vue?vue&type=script&lang=js"
import style0 from "./Passengeradd.vue?vue&type=style&index=0&id=bce6c47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce6c47a",
  null
  
)

export default component.exports